import React, { useMemo } from 'react';
import { FiActivity } from 'react-icons/fi';
import { FaRegLightbulb } from 'react-icons/fa';

const RecentPlansTable = ({ products = [], loading }) => {
    const recentPlans = useMemo(() => {
        return [...(products || [])].sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0)).slice(0, 5);
    }, [products]);
    
    if (loading) {
        return (
            <div className="bg-white rounded-xl shadow-sm p-5">
                <div className="animate-pulse">
                    <div className="h-5 bg-gray-200 rounded w-1/4 mb-6"></div>
                    <div className="space-y-3">
                        <div className="h-10 bg-gray-200 rounded w-full"></div>
                        {[1, 2, 3, 4].map(i => (
                            <div key={i} className="h-12 bg-gray-100 rounded w-full"></div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-xl shadow-sm p-5 overflow-hidden">
            <div className="flex justify-between items-center mb-5">
                <h3 className="text-lg font-semibold text-gray-800">Recent Plans</h3>
                <div className="p-2 rounded-lg bg-indigo-50">
                    <FiActivity className="text-indigo-500" />
                </div>
            </div>

            {recentPlans.length > 0 ? (
                <div className="overflow-x-auto">
                    <table className="w-full table-auto">
                        <thead>
                            <tr className="bg-gray-50 text-left">
                                <th className="px-4 py-3 text-sm font-semibold text-gray-600 rounded-l-lg">Name</th>
                                <th className="px-4 py-3 text-sm font-semibold text-gray-600">Price</th>
                                <th className="px-4 py-3 text-sm font-semibold text-gray-600">App</th>
                                <th className="px-4 py-3 text-sm font-semibold text-gray-600 rounded-r-lg">Billing</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {recentPlans.map(plan => (
                                <tr key={plan.id} className="hover:bg-blue-50/40 transition-colors duration-150">
                                    <td className="px-4 py-3 text-sm font-medium text-gray-800">{plan.name}</td>
                                    <td className="px-4 py-3 text-sm text-gray-700">
                                        <span className="font-semibold">${plan.price}</span>
                                        {plan.apply_promo === 1 && (
                                            <span className="ml-2 text-xs py-0.5 px-1.5 bg-green-100 text-green-800 rounded-sm">Promo</span>
                                        )}
                                    </td>
                                    <td className="px-4 py-3 text-sm text-gray-700">
                                        <span className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-blue-100 text-blue-800">
                                            {plan.app}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3 text-sm text-gray-700 capitalize">{plan.billable}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="py-8 text-center text-gray-500 bg-gray-50 rounded-lg">
                    <FaRegLightbulb className="mx-auto text-gray-400 mb-2" size={24} />
                    <p>No plans available. Add your first plan to get started!</p>
                </div>
            )}
        </div>
    );
};

export default RecentPlansTable; 